// Design tokens for Kidly — ported from the Claude Design bundle styles.css.
// Use these everywhere instead of hard-coded color/typography literals.

export const colors = {
  bg: "#FFF4E6",
  bgWarm: "#FFE8D1",
  surface: "#FFFFFF",
  ink: "#2E2316",
  ink2: "#6B5A48",
  ink3: "#A89685",
  line: "rgba(46,35,22,0.08)",
  lineStrong: "rgba(46,35,22,0.16)",
  primary: "#FF8A4C",
  primaryInk: "#B45A24",
  secondary: "#5B8DEF",
  success: "#7AC74F",
  star: "#FFD86B",
  pink: "#F18EB6",
  purple: "#8C7DD9",
  mint: "#27B59A",
  premium: "#B45A24",
  cheek: "rgba(244,120,90,0.35)",
};

// Mascot color presets used in profile creation
export const mascotColors = [
  "#F18EB6", // pink
  "#FF8A4C", // orange
  "#FFD86B", // yellow
  "#7AC74F", // green
  "#5B8DEF", // blue
  "#8C7DD9", // purple
];

export const radii = {
  xs: 6,
  sm: 10,
  md: 14,
  lg: 18,
  xl: 22,
  pill: 999,
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 14,
  lg: 20,
  xl: 28,
  xxl: 40,
};

export const fontFamily =
  // Nunito on web; falls back to system on native (custom fonts not loaded).
  "Nunito, -apple-system, BlinkMacSystemFont, system-ui, sans-serif";

export const typography = {
  // Display / headline
  h1: { fontSize: 30, fontWeight: "900" as const, letterSpacing: -0.3 },
  h2: { fontSize: 24, fontWeight: "900" as const, letterSpacing: -0.2 },
  h3: { fontSize: 20, fontWeight: "800" as const },
  // Body
  body: { fontSize: 16, fontWeight: "600" as const },
  bodyStrong: { fontSize: 16, fontWeight: "700" as const },
  // Eyebrow / label (small caps)
  eyebrow: {
    fontSize: 11,
    fontWeight: "800" as const,
    letterSpacing: 1.4,
    textTransform: "uppercase" as const,
  },
  caption: { fontSize: 13, fontWeight: "700" as const },
};

// TV typography (1040×585 stage)
export const tvType = {
  h1: { fontSize: 54, fontWeight: "900" as const, letterSpacing: -1 },
  h2: { fontSize: 38, fontWeight: "900" as const, letterSpacing: -0.5 },
  body: { fontSize: 22, fontWeight: "700" as const },
  small: { fontSize: 18, fontWeight: "600" as const },
};

export const shadows = {
  card: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.08,
    shadowRadius: 18,
    elevation: 4,
  },
  button: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.12,
    shadowRadius: 10,
    elevation: 3,
  },
};
